// builder.registry.ts
import {Builder} from "@builder.io/react";

// Import your custom components
import  SimpleAccordion  from "./components/guiComponents/SimpleAccordion";

// Initialize Builder with your API key
Builder.apiKey = process.env.REACT_APP_PUBLIC_BUILDER_KEY;

// Register your custom components
Builder.registerComponent(SimpleAccordion, {
  name: 'Simple Accordion',
  inputs: [
    { name: 'header', type: 'string' },
    { name: 'body', type: 'string' }
  ],
  image: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F6bef27ee40d24f3b88239fd7e616f82a'

});